import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea090af2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-wrap" }
const _hoisted_2 = {
  target: "_blank",
  href: "mailto:yolllo@yolllo.com",
  class: "sup-btn sup-btn_sm"
}
const _hoisted_3 = {
  target: "_blank",
  href: "https://telegram.me/Yolllo_bot",
  class: "sup-btn sup-btn_sm"
}
const _hoisted_4 = {
  target: "_blank",
  href: "http://wa.me/17867060439",
  class: "sup-btn sup-btn_sm"
}

import AppBtn from "@/components/slots/buttons/AppBtn.vue";
import SupportSvg from "@/components/icons/SupportSvg.vue";
import WhatsUpSvg from "@/components/icons/WhatsUpSvg.vue";
import TelegramLogoSvg from "@/components/icons/TelegramLogoSvg.vue";
import EmailLogoSvg from "@/components/icons/EmailLogoSvg.vue";
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";
import CloseGradientSvg from "@/components/icons/CloseGradientSvg.vue";
import { useToggleVisible } from "@/composition/common/useToggleVisible";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSupport',
  setup(__props) {

const el = ref();

let isOpened = ref(false);

const { toggle: toggleBtnsVisible, visible: btnsVisible } = useToggleVisible();

onClickOutside(el, () => {
  isOpened.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppBtn, {
      class: _normalizeClass(["sup-btn", { active: _unref(btnsVisible) }]),
      onClick: _unref(toggleBtnsVisible)
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(SupportSvg, null, null, 512), [
          [_vShow, !_unref(btnsVisible)]
        ]),
        _withDirectives(_createVNode(CloseGradientSvg, null, null, 512), [
          [_vShow, _unref(btnsVisible)]
        ])
      ]),
      _: 1
    }, 8, ["class", "onClick"]),
    _createVNode(_Transition, {
      name: "grow",
      duration: "1400"
    }, {
      default: _withCtx(() => [
        (_unref(btnsVisible))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sup-btns",
              ref_key: "el",
              ref: el
            }, [
              _createElementVNode("a", _hoisted_2, [
                _createVNode(EmailLogoSvg)
              ]),
              _createElementVNode("a", _hoisted_3, [
                _createVNode(TelegramLogoSvg)
              ]),
              _createElementVNode("a", _hoisted_4, [
                _createVNode(WhatsUpSvg)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})